export default __webpack_public_path__ + "files/media/s-fleet.188da329.jpg";